// extracted by mini-css-extract-plugin
module.exports = {"root":"video_root__g50oj","inner":"video_inner__7_SEn","wrapper":"video_wrapper__0vnAU","container":"video_container__10bCh","video":"video_video__n7yne"};